import {Page} from "../js/page";
import {GvfService} from "../../gvf/js/gvf-service";
import {ObjectService} from "../js/object-service";
import {UtilsService} from "../js/utils-service";

export class DetailPage extends Page{
    constructor(scope,$root){
        super(scope,$root);
        this.objectId = null;
        this.$detailForm = null;
        this.isEditing = null;
        this.cloningFromId = null;
    }

    ready(){
        super.ready();
        this.objectId = this.$root.data("model-id");
        this.$detailForm = this.findMember("main-form");
        let urlParams = new URLSearchParams(window.location.search);
        this.isEditing = urlParams.get('edit');
        this.objectService = new ObjectService(this.$root.data("model-name"));
        this.$detailModal = this.$root.closest(".js-detail-modal");
        this.$detailForm.submit(
            (ev) => {
                ev.preventDefault();
                this.$detailForm.checkRestrictions().then(
                    (isOk)=>{
                        if(isOk){
                            this.showLoading();
                            const values = this.$detailForm.getValues();
                            values.lang = this.$detailForm.data("lang");
                            if(this.cloningFromId){
                                values.__cloning_from_id = this.cloningFromId;
                                this.cloningFromId = null;
                            }
                            GvfService.endpoint(
                                this.$root.data("controller")+"/submit-detail-form",
                                {modelName: this.$root.data("model-name"),formData: values}
                            ).then(
                                (resp) => {
                                    this.hideLoading();
                                    if(this.$root.data("saveCallback")){
                                        this.$root.data("saveCallback")(resp.id,resp);
                                    }else{
                                        if(resp.reload){
                                            window.location.reload();
                                        }else{
                                            window.location = resp.url;
                                        }
                                    }
                                }
                            ).catch(
                                (resp) => {
                                    this.hideLoading();
                                    if(resp.validation){
                                        this.$detailForm.applyValidationResponse(resp.validation);
                                    }else{
                                        UtilsService.alertEndpointResponse(resp);
                                    }
                                }
                            );
                        }
                    }
                );
            }
        );

        this.findMember("create").click(
            (ev) => {
                if(this.$detailModal.length>0){
                    ev.preventDefault();
                    this.objectService.openDetailModal(
                        {
                            objectId:this.objectId,
                            editMode:$(ev.currentTarget).is(this.scope+"__edit"),
                            saveCallback:this.$root.data("saveCallback"),
                            data:this.$root.data("modalData"),
                            deleteCallback:this.$root.data("deleteCallback")
                        }
                    );

                    this.openModal(
                        this.$root.data("model-name"),
                        null,
                        true,
                        null,
                        (id) => {
                            if(this.$detailModal.data("refreshModal")){
                                this.$detailModal.data("refreshModal")();
                            }else{
                                this.$detailModal.data("addValue")(id);
                            }
                        },
                        this.$root.data("modalData")
                    );
                }
            }
        );

        this.findMember("delete").click(
            (ev) => {
                ev.preventDefault();
                const lang = this.$detailForm.data("lang");
                this.objectService.deleteObject({
                    ids: this.$root.find("[name=id]").val(),
                    lang: lang,
                    controller: this.$root.data("controller"),
                    redirectUser:!this.$root.data("deleteCallback")
                }).then(this.$root.data("deleteCallback"));
            }
        );

        this.findMember("save").click(
            (ev) => {
                ev.preventDefault();
                this.findMember("main-form").submit();
            }
        );

        this.findMember("save-new").click(
            (ev) => {
                ev.preventDefault();
                this.cloningFromId = this.$root.find("[name=id]").val();
                this.$root.find("[name=id]").val("");
                this.findMember("main-form").submit();
            }
        );

        this.findMember(["view","edit"]).click(
            (ev) => {
                if(this.$detailModal.length>0){
                    ev.preventDefault();
                    this.$detailModal.modal("hide");
                    this.objectService.openDetailModal(
                        {
                            objectId:this.objectId,
                            editMode:$(ev.currentTarget).is(this.scope+"__edit"),
                            saveCallback:this.$root.data("saveCallback"),
                            data:this.$root.data("modalData"),
                            deleteCallback:this.$root.data("deleteCallback")
                        }
                    );
                }
            }
        );
    }
}

